import { jsxs as i, Fragment as z, jsx as t } from "react/jsx-runtime";
import { useState as V } from "react";
import { FAIcon as p } from "@nextgen-web-framework/all";
import u from "../ImageAndTextContainer/ImageAndTextContainer.js";
import { ComponentType as k } from "../../cms/registries/types/propTypes.js";
import _ from "../../cms/component-transformers/text-only-transformer/text-only-transformer.js";
import y from "../../cms/component-transformers/ImageAndText-transformer/ImageAndText-transformer.js";
import { T as b } from "../../TextOnly-1d491347.mjs";
import '../../assets/AccordionComponent.css';const B = "#ffffff", $ = "#396e75", j = "#e5fdff", A = "#546223", O = "#f0fae5", G = "#a65523", N = "#fff1e8", T = "#7f3e3e", w = "#ffe2e2", I = "#62625a", v = "#f8f8e7", x = "#38539a", R = "#707070", W = "#c8f8d1", Y = "#87c9c8", F = "#5291b1", S = "rgba(82, 145, 177, 0.1019607843)", P = "#445685", D = "#181d61", q = "rgba(24, 29, 97, 0.1019607843)", E = "#5969d6", H = "#ea999d", J = "#b6577e", K = "rgba(182, 87, 126, 0.1019607843)", L = "#7e3e80", M = "#1e247f", Q = "rgba(30, 36, 127, 0.1019607843)", U = "#da7600", X = "#107f47", Z = "#d91734", oo = "_html_p9jyu_38", ao = "_icon_p9jyu_114", a = {
  amwayWhite: B,
  darkBlue: $,
  lightBlue: j,
  darkGreen: A,
  lightGreen: O,
  darkOrange: G,
  lightOrange: N,
  darkRed: T,
  lightRed: w,
  darkYellow: I,
  lightYellow: v,
  darkPurple: x,
  darkGrayOnWhite: R,
  dataVizColor1: W,
  dataVizColor2: Y,
  dataVizColor3: F,
  dataVizColor3Background: S,
  dataVizColor4: P,
  dataVizColor5: D,
  dataVizColor5Background: q,
  dataVizColor6: E,
  dataVizColor7: H,
  dataVizColor8: J,
  dataVizColor8Background: K,
  dataVizColor9: L,
  dataVizColor10: M,
  dataVizColor10Background: Q,
  dataVizAlertOrange: U,
  dataVizSuccessGreen: X,
  dataVizWarningRed: Z,
  "no-visible": "_no-visible_p9jyu_34",
  html: oo,
  "cms-accordion-section-title": "_cms-accordion-section-title_p9jyu_72",
  "cms-accordion-component": "_cms-accordion-component_p9jyu_82",
  "accordion-toggle": "_accordion-toggle_p9jyu_89",
  "accordion-header": "_accordion-header_p9jyu_92",
  "accordion-title": "_accordion-title_p9jyu_104",
  icon: ao,
  "accordion-content-body": "_accordion-content-body_p9jyu_122"
}, mo = (m) => {
  const { accordionItemArr: g, sectionTitle: c } = m, e = `cms-accordion-component-${c}`, [f, h] = V(), C = (o) => {
    const {
      target: { id: r, checked: d }
    } = o;
    h(d ? r : "");
  };
  return /* @__PURE__ */ i(z, { children: [
    c && /* @__PURE__ */ t("h3", { className: a["cms-accordion-section-title"], children: c }),
    g.map(({ accordion_title: o, collapsed_content_section: r, ...d }, n) => {
      let l = u, s = y;
      return r === k.text_only && (l = b, s = _), /* @__PURE__ */ i("section", { className: a["cms-accordion-component"], children: [
        /* @__PURE__ */ t(
          "input",
          {
            type: "checkbox",
            id: `${e}-${n}-${o}`,
            className: a["accordion-toggle"],
            name: `cms-accordion-item-${o}`,
            checked: f === `${e}-${n}-${o}`,
            onChange: C
          }
        ),
        /* @__PURE__ */ i(
          "label",
          {
            htmlFor: `${e}-${n}-${o}`,
            className: a["accordion-header"],
            "data-testid": `testid-${n}`,
            children: [
              /* @__PURE__ */ t("h4", { className: a["accordion-title"], children: o }),
              /* @__PURE__ */ t(p, { iconName: "chevron-down", className: a.icon })
            ]
          }
        ),
        /* @__PURE__ */ t("div", { role: "contentinfo", className: a["accordion-content-body"], children: /* @__PURE__ */ t(l, { ...s(d) }) })
      ] }, o);
    })
  ] });
};
export {
  mo as default
};
//# sourceMappingURL=AccordionComponent.js.map
